import {Alert} from '@mui/material';
import {useZeroNeetAuth} from '../utils/useZeroNeetAuth';
import Dashboard1 from '../Dashboard1';

// "Le nostre attività" page — Dashboard 1 (Attività di intercettazione dei NEET).
const ZeroNeetActivities = () => {
    const {container, uoaId, surveyIds, isAuthorized} = useZeroNeetAuth(['survey1_id', 'survey2_id']);

    if (!isAuthorized) {
        return <Alert severity='error'>Parametri mancanti o chiave non valida.</Alert>;
    }

    return (
        <Dashboard1
            container={container!}
            uoaId={uoaId!}
            survey499Id={surveyIds.survey1_id!}
            survey500Id={surveyIds.survey2_id!}
        />
    );
};

export default ZeroNeetActivities;
